<template>
  <div class="error container-fluid fullHeight margin-Top-3Perc">
    <div class="row">
      <div class="col-lg-12">
       <img src= "../assets/images/404error.svg" class="img-responsive icon-width-height align-center"> 
      </div>
    </div>
    <div class="row">
      <div class="text-align-center fourOFourSizecolor">
        404
      </div>
    </div>
    <div class="row text-align-center pageNotFound">
       {{msg}}
    </div>
    <div class="row text-align-center pageErrorMsg margin-Top-2Perc">
       The Page you are looking for does not exist.
    </div>
  </div>  
</template>

<script>
require('bootstrap/dist/css/bootstrap.min.css')

export default {
  data: function () {
    return {
      msg: 'Page Not Found'
    }
  },
  name: 'error'
}
</script>

<style scoped>
.error{
  /* background-color:#f8f8f8; */
}
.home {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.text-align-center{
  text-align: center;
}
img{
    display: block;
    margin-left: auto;
    margin-right: auto;
    /* width: 40%; */
}
.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.left-color-border
{
	border: 1px solid red;
}
.fourOFourSizecolor{
  font-family: "Proxima Nova";
  font-size:150px;
  color:#777777;
  font-weight: bold;
}
.pageNotFound{
  font-family: "Proxima Nova";
  font-size:72px;
  color:#868686;
  font-weight: bold;  
}
.pageErrorMsg{
  font-family: "Proxima Nova Regular";
  font-size:36px;
  color:#868686;
  font-weight: regular;  

}
.right-color-border
{
	border: 1px solid green;
}
.leftNavBarBG
{
	background-color: #34495e;
  /*border:1px solid #34495e; */
}
.font-size-14px{
	font-size: 30px;
}
.position-Fixed
{
	position:fixed;
}
.float-Right
{
	float: right;
}
.fullHeight
{
	height:100% !important;
}
.fi-border
{
	border: 1px solid white;
}
 .footer-img
 {
    margin: 0 auto !important;
    display: block;
    position: absolute;
    bottom: 0;
	width: 30%;
 }
 .center-block {
   margin-left:auto;
   margin-right:auto;
   display:block;
}
.text-center {
   text-align:center
}
.margin-Top-14Perc
{
	margin-top: 14%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}

.margin-Top-5Perc
{
	margin-top: 5%;
}
.admin-Panel-BG
{
  background-color: #f39c12;
}
.text-align-left
{
  text-align: left;
}
.margin-Left-4Perc
{
  margin-left: 4%;
}
.admin-Panel-Padding
{
  padding:0.1% 0% 0.1% 2%;
}
.font-size-2vw
{
  font-size: 2vw;
}
</style>



// WEBPACK FOOTER //
// src/pages/Error.vue